import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';

export const TalentSetting = ({ toggleTalentNetwork, tnHidden, title, description, sx, disabled }) => (
  <Flex alignItems="center" justifyContent="space-between" sx={{ gap: '16px', ...sx }}>
    <Flex sx={{ flexDirection: 'column', rowGap: '4px' }}>
      <Text
        lineHeight="140%"
        fontSize={toggleTalentNetwork ? '14px' : '16px'}
        fontWeight={toggleTalentNetwork ? '500' : '600'}
        as="h4"
      >
        {title}
      </Text>
      {description && (
        <Text as="p" color="text.main" lineHeight="20px" fontSize="14px">
          {description}
        </Text>
      )}
    </Flex>
    {toggleTalentNetwork && (
      <Toggle disabled={disabled} size="large" onChange={toggleTalentNetwork} checked={tnHidden} />
    )}
  </Flex>
);

TalentSetting.propTypes = {
  toggleTalentNetwork: PropTypes.func,
  tnHidden: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
};

TalentSetting.defaultProps = {
  toggleTalentNetwork: null,
  tnHidden: false,
  description: null,
  sx: {},
  disabled: false,
};
